import {
    CONTINUE_PAYMENT_BEGIN,
    CONTINUE_PAYMENT_SUCCESS,
    CONTINUE_PAYMENT_FAILURE
} from '../constants'
import { ACTION_STATE } from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
        case CONTINUE_PAYMENT_BEGIN:
            return {
                ...state,
                continuePaymentState: ACTION_STATE.PENDING
            }
        case CONTINUE_PAYMENT_SUCCESS:
            return {
                ...state,
                continuePaymentState: ACTION_STATE.SUCCESS,
                urlContinuePayment: action.data.urlContinuePayment
            }
        case CONTINUE_PAYMENT_FAILURE:
            return {
                ...state,
                continuePaymentState: ACTION_STATE.ERROR
            }
        default:
            return state
    }
}